import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { compose } from '@atlaskit/editor-common/utils';
import { SortOrder } from '@atlaskit/editor-common/types';
import { RendererCssClassName } from '../../consts';
export default class TableRow extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      colGroupWidths: []
    });
    _defineProperty(this, "addSortableColumn", childrenArray => {
      const {
        allowColumnSorting,
        index: rowIndex
      } = this.props;
      if (allowColumnSorting) {
        const isHeaderRow = !rowIndex;
        childrenArray = childrenArray.map((child, index) => {
          if ( /*#__PURE__*/React.isValidElement(child)) {
            const {
              tableOrderStatus
            } = this.props;
            let sortOrdered = SortOrder.NO_ORDER;
            if (tableOrderStatus) {
              sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : SortOrder.NO_ORDER;
            }
            return /*#__PURE__*/React.cloneElement(child, {
              columnIndex: index,
              onSorting: this.props.onSorting,
              sortOrdered,
              isHeaderRow
            });
          }
        });
      }
      return childrenArray;
    });
    _defineProperty(this, "addColGroupWidth", childrenArray => {
      if (this.state.colGroupWidths) {
        childrenArray = childrenArray.map((child, index) => {
          if ( /*#__PURE__*/React.isValidElement(child)) {
            return /*#__PURE__*/React.cloneElement(child, {
              colGroupWidth: this.state.colGroupWidths[index]
            });
          }
        });
      }
      return childrenArray;
    });
  }
  render() {
    const {
      children,
      innerRef
    } = this.props;
    const childrenArray = React.Children.toArray(children);
    return /*#__PURE__*/React.createElement("tr", {
      ref: innerRef
    }, this.props.isNumberColumnEnabled && /*#__PURE__*/React.createElement("td", {
      className: RendererCssClassName.NUMBER_COLUMN
    }, this.props.index), compose(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
  }
}